import { jsx as C } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ C(
  "path",
  {
    d: "M22 10.4219C22 9.55061 21.5512 8.73695 20.8041 8.25363L13.5645 2.45965C12.6171 1.84678 11.3829 1.84678 10.4355 2.45965L3.19592 8.25363C2.44878 8.73695 2 9.55061 2 10.4219V19.2632C2 20.7747 3.26279 22 4.82051 22H19.1795C20.7372 22 22 20.7747 22 19.2632L22 10.4219ZM6.69303 13.8796C6.68479 13.3274 7.12577 12.8731 7.678 12.8648L11.0144 12.815L11.0642 9.47857C11.0725 8.92634 11.5268 8.48536 12.0791 8.4936C12.6313 8.50185 13.0723 8.95619 13.064 9.50842L13.0151 12.7852L16.2918 12.7362C16.8441 12.728 17.2984 13.169 17.3067 13.7212C17.3149 14.2734 16.8739 14.7278 16.3217 14.736L12.9852 14.7858L12.9355 18.1223C12.9272 18.6745 12.4729 19.1155 11.9206 19.1072C11.3684 19.099 10.9274 18.6446 10.9357 18.0924L10.9846 14.8157L7.70785 14.8646C7.15562 14.8728 6.70128 14.4318 6.69303 13.8796Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
export {
  e as default
};
